export default __webpack_public_path__ + "static/media/audio.2b2b34eb.png";